import { Inject, PLATFORM_ID, NgZone } from '@angular/core';

export class DisplayService {

    constructor() {
    }

    public scrollToClass(ngZone: NgZone, className: string, timeout = 50): void {
        this.runOutsideAngular(ngZone, () => {
            let tags = document.getElementsByClassName(className);
            if (!tags) {
                return;
            }
            let elem: any;
            elem = tags[0];
            if (!elem) {
                return;
            }
            elem.style.display = "block";
            elem.scrollIntoView({ behavior: "smooth", block: "end" });
        }, timeout);
    }

    public runOutsideAngular(ngZone: NgZone, callback: () => any, timeout: number = 200) {
        ngZone.runOutsideAngular(function () {
            setTimeout(function () {
                ngZone.run(function () {
                    callback();
                });
            }, timeout);
        });
    }
}
